var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "paysolus-notice"
  }, [_vm._m(0), _c('p', [_vm._v("선불전자지급수단 발행 및 관리업 등록번호 02-002-00020")]), _c('p', {
    staticClass: "mt-8px"
  }, [_vm._v("상품권의 구매, 충전, 환불과 고객문의 사항은 페이솔루스의 이용약관 및 상품권 운영 정책에 따릅니다.")]), _c('v-img', {
    staticClass: "mx-auto mt-20px mt-lg-40px",
    attrs: {
      "src": "/images/paysolus-logo.png",
      "alt": "PAYSOLUS",
      "max-width": "150"
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', [_vm._v("본 상품권의 선불전자지급수단 발행·관리 및 운영 업무는 「전자금융거래법」에 따라 등록된 "), _c('br'), _vm._v("선불전자금융업자 페이솔루스에서 관리합니다.")]);
}]

export { render, staticRenderFns }